import type { JSX } from 'react';
import type { InspectionVerification } from '../types/inspection.types';

interface InspectionClaimProps {
  verification: InspectionVerification;
}

function experienceLabel(verification: InspectionVerification): string | null {
  const { experienceJobTitle, experienceCompanyName } = verification;
  if (!experienceJobTitle) {
    return experienceCompanyName ?? null;
  }
  if (!experienceCompanyName) {
    return experienceJobTitle;
  }
  return `${experienceJobTitle} at ${experienceCompanyName}`;
}

/**
 * The claim a super admin is asked to judge: whose experience it is, which company
 * owns the record, and what the candidate says they did.
 */
export function InspectionClaim({ verification }: InspectionClaimProps): JSX.Element | null {
  const experience = experienceLabel(verification);
  const { candidateName, companyName } = verification;

  if ([candidateName, experience, companyName].every((line) => !line)) {
    return null;
  }

  return (
    <div className="space-y-0.5">
      {candidateName && <p className="font-semibold">{candidateName}</p>}
      {experience && <p className="text-sm">{experience}</p>}
      {companyName && <p className="text-xs text-muted-foreground">{companyName}</p>}
    </div>
  );
}
